import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  TextField,
  Backdrop,
  makeStyles,
  CircularProgress
} from '@material-ui/core'
import { acceptIrpIncidence } from '../../api/irpIncidences.service'
import LoadMultipleFiles from '../../components/Resources/LoadMultipleFiles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const AcceptIrpIncidence = (params) => {
  const classes = useStyles
  const id = params.id
  const open = params.open
  const onSave = params.onSave
  const onCancel = params.onCancel

  const [stateForm, setStateForm] = useState({
    comment: ''
  })
  const [resources, setResources] = useState([])
  const [loading, setLoading] = useState(false)

  const handleInputChange = (event) => {
    const value = event.target.value
    const name = event.target.name

    setStateForm({
      ...stateForm,
      [name]: value
    })
  }

  const handleAccept = async () => {
    const params = {
      ...stateForm,
      id: id,
      attachments: resources
    }
    setLoading(true)
    await acceptIrpIncidence(params)
      .then(() => {
        onSave()
        onCancel()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div>
      <Dialog open={open}>
        <DialogContent>
          <Typography>{`¿Está seguro de que desea aceptar la incidencia IRP ${id}?`}</Typography>
          <TextField
            type="text"
            label="Comentario"
            placeholder="¿Tiene algún comentario? "
            name="comment"
            fullWidth
            variant="outlined"
            className="my-3"
            multiline
            rows={3}
            value={stateForm.comment}
            disabled={loading}
            onChange={handleInputChange}
          />
          <LoadMultipleFiles canDelete={true} resources={resources} setResources={setResources} />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleAccept} autoFocus color="secondary">
            Aceptar
          </Button>
          <Button disabled={loading} onClick={onCancel}>
            Cancelar
          </Button>
        </DialogActions>
        <Backdrop className={classes.backdrop} open={loading} onClick={onCancel}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
    </div>
  )
}

export default AcceptIrpIncidence
